import { useMemo } from 'react';
import { useEventsQuery, useWeddingWebsiteQuery } from '../generated/graphql';
import { getHpLocation } from '../helpers/getHpLocation';

export const offsetDateByDays = (days: number, date?: Date) => {
  if (!date) {
    return null;
  }

  const offsetDate = new Date(date);

  offsetDate.setDate(offsetDate.getDate() + days);

  return offsetDate;
};

export const formatDateString = (date: Date) => {
  if (!date) {
    return '';
  }

  return date.toISOString().split('T')[0];
};

export const getWeddingDate = (dateOffsetInDays: number, memberWeddingDate?: Date, memberWeddingRangeDate?: Date) => {
  let checkInDate;

  const dayBeforeWedding = offsetDateByDays(dateOffsetInDays, memberWeddingDate);

  const dayBeforeWeddingRange = offsetDateByDays(dateOffsetInDays, memberWeddingRangeDate);

  checkInDate = memberWeddingRangeDate ? dayBeforeWeddingRange : dayBeforeWedding;

  return checkInDate;
};

export const getCheckInDate = (weddingDate?: string, weddingDateRangeStart?: string | null) => {
  return getWeddingDate(
    -1,
    weddingDate ? new Date(weddingDate) : undefined,
    weddingDateRangeStart ? new Date(weddingDateRangeStart) : undefined
  );
};

export const getCheckOutDate = (weddingDate?: string, weddingDateRangeEnd?: string | null) => {
  return getWeddingDate(
    1,
    weddingDate ? new Date(weddingDate) : undefined,
    weddingDateRangeEnd ? new Date(weddingDateRangeEnd) : undefined
  );
};

export const useGetHotelEngineUrl = () => {
  const { data } = useWeddingWebsiteQuery();
  const { data: eventsData } = useEventsQuery();

  const weddingLocation: string | undefined | null = useMemo(
    () => getHpLocation(eventsData?.events, data?.weddingWebsite?.weddingLocation),
    [data, eventsData]
  );

  const weddingDate = data?.wedding?.weddingDate;
  const weddingDateRangeStart = data?.weddingWebsite?.weddingDateRangeStart;
  const weddingDateRangeEnd = data?.weddingWebsite?.weddingDateRangeEnd;

  const checkInDate = getCheckInDate(weddingDate, weddingDateRangeStart);
  const checkOutDate = getCheckOutDate(weddingDate, weddingDateRangeEnd);

  const getHotelEngineUrl = (): string => {
    const engineUrlBase = process.env.REACT_APP_ENGINE_ROOM_BLOCKS_URL || '';

    const engineUrl = new URL(engineUrlBase);
    if (weddingLocation) {
      engineUrl.searchParams.set('city', weddingLocation);
    }

    if (checkInDate) {
      engineUrl.searchParams.set('checkIn', formatDateString(checkInDate));
    }
    if (checkOutDate) {
      engineUrl.searchParams.set('checkOut', formatDateString(checkOutDate));
    }

    engineUrl.searchParams.set('utm_source', 'the-knot');
    engineUrl.searchParams.set('utm_medium', 'channel');
    engineUrl.searchParams.set('utm_campaign', 'the-knot-channel-groups-a018X00000bV3kuQAC');
    engineUrl.searchParams.set('utm_term', 'tkwws');
    engineUrl.searchParams.set('referral', 'MKT - Partner');

    return engineUrl.toString();
  };

  return { getHotelEngineUrl };
};
